import { render } from "./Signetfull.vue?vue&type=template&id=cc618e50&scoped=true"
import script from "./Signetfull.vue?vue&type=script&lang=js"
export * from "./Signetfull.vue?vue&type=script&lang=js"

import "./Signetfull.vue?vue&type=style&index=0&id=cc618e50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cc618e50"

export default script